export const ROLES = {
  SUPER_ADMIN: 'super_admin',
  KYC_REVIEWER: 'kyc_reviewer',
  PRODUCT_MANAGER: 'product_manager',
  FINANCE_MANAGER: 'finance_manager',
  SUPPORT_AGENT: 'support_agent',
  LOGISTICS_MANAGER: 'logistics_manager',
};

export const ROLE_LABELS = {
  super_admin: 'Super Admin',
  kyc_reviewer: 'KYC Reviewer',
  product_manager: 'Product Manager',
  finance_manager: 'Finance Manager',
  support_agent: 'Support Agent',
  logistics_manager: 'Logistics Manager',
};

export const ROLE_COLORS = {
  super_admin: '#C9A84C',
  kyc_reviewer: '#B0B8C1',
  product_manager: '#52C41A',
  finance_manager: '#9A7A2E',
  support_agent: '#D4DCE3',
  logistics_manager: '#7A8A96',
};

export const ROLE_PERMISSIONS = {
  super_admin: {
    canViewKYC: true,
    canApproveKYC: true,
    canViewProducts: true,
    canApproveProducts: true,
    canChangeTier: true,
    canViewFinance: true,
    canProcessPayouts: true,
    canViewOrders: true,
    canManageOrders: true,
    canViewUsers: true,
    canSuspendUsers: true,
    canBanUsers: true,
    canViewLeads: true,
    canConfigLeads: true,
    canViewLogistics: true,
    canManageLogistics: true,
    canViewSupport: true,
    canResolveSupport: true,
    canViewAnalytics: true,
    canConfigCommission: true,
    canManageAdminUsers: true,
  },
  kyc_reviewer: {
    canViewKYC: true,
    canApproveKYC: true,
    canViewProducts: false,
    canApproveProducts: false,
    canChangeTier: false,
    canViewFinance: false,
    canProcessPayouts: false,
    canViewOrders: false,
    canManageOrders: false,
    canViewUsers: true,
    canSuspendUsers: false,
    canBanUsers: false,
    canViewLeads: false,
    canConfigLeads: false,
    canViewLogistics: false,
    canManageLogistics: false,
    canViewSupport: false,
    canResolveSupport: false,
    canViewAnalytics: false,
    canConfigCommission: false,
    canManageAdminUsers: false,
  },
  product_manager: {
    canViewKYC: false,
    canApproveKYC: false,
    canViewProducts: true,
    canApproveProducts: true,
    canChangeTier: true,
    canViewFinance: false,
    canProcessPayouts: false,
    canViewOrders: true,
    canManageOrders: false,
    canViewUsers: true,
    canSuspendUsers: false,
    canBanUsers: false,
    canViewLeads: false,
    canConfigLeads: false,
    canViewLogistics: false,
    canManageLogistics: false,
    canViewSupport: true,
    canResolveSupport: false,
    canViewAnalytics: true,
    canConfigCommission: false,
    canManageAdminUsers: false,
  },
  finance_manager: {
    canViewKYC: false,
    canApproveKYC: false,
    canViewProducts: false,
    canApproveProducts: false,
    canChangeTier: false,
    canViewFinance: true,
    canProcessPayouts: true,
    canViewOrders: true,
    canManageOrders: false,
    canViewUsers: true,
    canSuspendUsers: false,
    canBanUsers: false,
    canViewLeads: true,
    canConfigLeads: false,
    canViewLogistics: false,
    canManageLogistics: false,
    canViewSupport: false,
    canResolveSupport: false,
    canViewAnalytics: true,
    canConfigCommission: false,
    canManageAdminUsers: false,
  },
  support_agent: {
    canViewKYC: false,
    canApproveKYC: false,
    canViewProducts: false,
    canApproveProducts: false,
    canChangeTier: false,
    canViewFinance: false,
    canProcessPayouts: false,
    canViewOrders: true,
    canManageOrders: false,
    canViewUsers: true,
    canSuspendUsers: false,
    canBanUsers: false,
    canViewLeads: false,
    canConfigLeads: false,
    canViewLogistics: true,
    canManageLogistics: false,
    canViewSupport: true,
    canResolveSupport: true,
    canViewAnalytics: false,
    canConfigCommission: false,
    canManageAdminUsers: false,
  },
  logistics_manager: {
    canViewKYC: false,
    canApproveKYC: false,
    canViewProducts: false,
    canApproveProducts: false,
    canChangeTier: false,
    canViewFinance: false,
    canProcessPayouts: false,
    canViewOrders: true,
    canManageOrders: false,
    canViewUsers: true,
    canSuspendUsers: false,
    canBanUsers: false,
    canViewLeads: false,
    canConfigLeads: false,
    canViewLogistics: true,
    canManageLogistics: true,
    canViewSupport: false,
    canResolveSupport: false,
    canViewAnalytics: false,
    canConfigCommission: false,
    canManageAdminUsers: false,
  },
};